import React from "react";
import "../styles/dvorane.css";
import Header from "./header.js";
import Footer from "./footer.js";
import DvoranaSlika from "./dvoranaSlika.js";
import { spojiDane } from "./dvoraneData.js";
import { useSEO } from "./seo.js";

const Dvorane = ({ dvorane, loading }) => {
  useSEO({
    naslov: "Dvorane i termini treninga - OK Virtus",
    opis: "Dvorane u kojima trenira Odbojkaški klub Virtus - termini treninga po razredima u OŠ Fran Galović, OŠ Lučko, OŠ Klinča Sela i OŠ Ljubo Babić.",
    putanja: "/dvorane",
  });

  return (
    <div>
      <Header />

      <div className="sadrzaj-dvorane">
        <h1>Dvorane</h1>

        {loading ? (
          <p className="dvorane-status">Učitavanje dvorana...</p>
        ) : dvorane.length > 0 ? (
          <div className="dvorane-grid">
            {dvorane.map((dvorana) => (
              <div key={dvorana.id} className="dvorana-kartica">
                <div className="img-container">
                  <DvoranaSlika
                    src={dvorana.slika}
                    alt={dvorana.naziv}
                    className="dvorana-img"
                  />
                </div>

                <div className="dvorana-info">
                  <h2 className="dvorana-naziv">
                    {dvorana.naziv.split(" | ")[0]}
                    {dvorana.naziv.includes(" | ") && (
                      <span className="dvorana-kvart">
                        ({dvorana.naziv.split(" | ")[1]})
                      </span>
                    )}
                  </h2>
                  <a
                    href={dvorana.googleMapsLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {dvorana.lokacija}
                  </a>
                  <div className="dvorana-termini">
                    <h3>Termini treninga:</h3>
                    <ul>
                      {dvorana.termini.map((grupa, index) => (
                        <li key={index}>
                          {grupa.kategorija && (
                            <span className="termin-kategorija">
                              {grupa.kategorija}
                            </span>
                          )}
                          {grupa.stavke.map((stavka, i) => (
                            <div key={i} className="termin-red">
                              <span className="termin-dani">
                                {spojiDane(stavka.dani)}
                              </span>
                              <span className="termin-vrijeme">
                                {stavka.vrijeme}
                              </span>
                            </div>
                          ))}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="dvorane-status">Trenutno nema podataka o dvoranama.</p>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Dvorane;
